
/**
 * 추가 메타데이터
 */
export type HandleWebhookBodyMetadata = { [key: string]: unknown };
